import application from 'application/application';

const controller = 'DefaultMovementsController';

application

	.controller(controller, [() => {}]);

export default controller;
